<template>
 
    <v-container>
      <v-row>
        <v-col cols="12" md="5" class="py-12"
          ><v-row no-gutters>
            <v-col cols="12">
              <Logo />
            </v-col>
            <v-col cols="12">
              <p class="mt-8 text-justify" style="max-width: 400px">
                Welcome to our quick delivery system! Whether you're managing a
                market, or delivery company, we offer the best
                solutions to streamline your operations. Our platform provides
                efficient options tailored to your specific needs.
              </p>
            </v-col>
            <v-col cols="12">
              <v-list two-line class="transparent">
                <!-- <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-map-marker </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>ADDRESS</v-list-item-title>
                    <v-list-item-subtitle>-</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider> -->
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-email </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>EMAIL</v-list-item-title>

                    <v-list-item-subtitle
                      >support@pexcode.com</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-phone </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>PHONE</v-list-item-title>
                    <v-list-item-subtitle
                      >(+49) 179 3901116</v-list-item-subtitle
                    >

                    <!-- <v-list-item-subtitle>(650) 555-1234</v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon> mdi-whatsapp </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>WHATSAPP</v-list-item-title>
                    <v-list-item-subtitle
                      >(+49) 179 3901116</v-list-item-subtitle
                    >
                    <!-- <v-list-item-subtitle>(650) 555-1234</v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
              </v-list>
              <div class="d-flex justify-center mt-5">
                <v-btn
                  v-for="(socialm, i) in social"
                  :key="`social-${i}`"
                  class="d-flex"
                  icon
                  large
                  color="primary"
                  :href="socialm.link"
                  target="_blank"
                >
                  <v-icon>{{ socialm.icon }}</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row></v-col
        >
        <v-col cols="1" class="text-center hidden-sm-and-down col col-2 py-12">
          <v-divider vertical></v-divider>
        </v-col>
        <v-col cols="12" md="5" class="py-12">
          <h3 class="mb-8">SEND YOUR MESSAGE</h3>
          <footerContactForm />
        </v-col>
      </v-row>
    </v-container> 
</template>

<script>
import footerContactForm from './footerContactForm.vue'
import Logo from './Logo.vue'
export default {
  components: {
    footerContactForm,Logo
  },
  data() {
    return {
      social: [
        {
          platform: 'Facebook',
          link: 'https://www.facebook.com/quickdeliverysystem/',
          icon: 'mdi-facebook',
        },
        // {
        //   platform: 'Twitter',
        //   link: 'https://twitter.com/',
        //   icon: 'mdi-twitter',
        // },
        // {
        //   platform: 'Instagram',
        //   link: 'https://www.instagram.com/',
        //   icon: 'mdi-instagram',
        // },
        // {
        //   platform: 'Linkedin',
        //   link: 'https://www.linkedin.com/',
        //   icon: 'mdi-linkedin',
        // },
        // {
        //   platform: 'Github',
        //   link: 'https://modevue.staticdesigner.com/',
        //   icon: 'mdi-github',
        // },
        {
          platform: 'Blog',
          link: 'https://quickdeliverysystem.com/blog/',
          icon: 'mdi-wordpress',
        },
      ],
    }
  },
}
</script>
